"use client";

export { ClientConfigProvider, useConfig } from "@jetblue/dotcom-config/client";
